import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import useOnEventOutside from '../../hooks/useOnEventOutside';
import DropdownIcon from '../../icons/dropdown.svg';

import styles from './index.module.scss';

const cx = classNames.bind(styles);

const Dropdown = ({
  value,
  label,
  dismissEvents,
  items,
  onDismiss,
  onSelect,
}) => {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(false);

  const wrapperRef = useRef(null);

  useEffect(() => setActive(!!value || value === 0), [value]);

  const onClose = () => {
    setOpen(false);
    if (onDismiss) {
      onDismiss();
    }
  };

  useOnEventOutside(wrapperRef, onClose, dismissEvents || ['mousedown']);

  return (
    <div ref={wrapperRef} className={styles.dropdown} onClick={() => setOpen(!open)}>
      <DropdownIcon className={styles.icon} />
      <div>
        <div className={styles.labelWrapper}>
          <div className={cx({ label: true, labelActive: active || open })}>{label}</div>
          <span>{value}</span>
        </div>
      </div>
      <div
        className={`${styles.wrapper} ${open ? styles.open : ''}`}
      >
        <div
          className={styles.list}
          onClick={() => {
            if (dismissEvents && dismissEvents.includes('click')) {
              setOpen(false);
            }
          }}
        >
          {items && items.filter((item) => item !== null)
            .map((item) => (
              <div
                key={item}
                onClick={() => {
                  onSelect(item);
                  setOpen(false);
                }}
                className={styles.item}
              >
                {item}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

Dropdown.propTypes = {
  onDismiss: PropTypes.func,
  onSelect: PropTypes.func,
  dismissEvents: PropTypes.func,
  value: PropTypes.string,
  label: PropTypes.string,
  items: PropTypes.array,
};

export default Dropdown;
